module.exports = __webpack_public_path__ + "img/ICONE-IDENT-PRIMARY.0db88125.svg";